/* eslint-disable default-case */
import React from 'react';
import C18Anchor00 from './C18Anchor00'
import C18Button00 from './C18Button00'
import { DateRangePicker } from 'react-date-range';
import '../../rdr_styles.css'
import '../../rdr_default.css'
import {loadSitesInfo,loadZonesInfo,loadAlarmsInfo,loadAddedSensorsInfo,getSiteInfo,
  getAlarmInfo,loadSensorsInfo,
  getZoneAlarmInfo,getZoneIndex,loadMBInfo,
  isAlarmAcknowledged,markAlarmsAcknowledged,alarmOccurrenceKey,
  getSiteName,getZoneName,setSiteZoneTypes,loadSiteData,privs} from './C18utils'
  import {wsTrans,sensorIds,alarmToSensor,makeSiteSensorNames,siteSensorNames,getParamId,getParamId2,getTzo,getTZIndicator,getDst} from '../utils/utils';
import {cl,globs,constant,dateToDisplayDate} from '../../components/utils/utils';
import LoadingSpinner from './loadingSpinner';
import {p,pi,pInd} from '../../components/utils/paramIds'
import {dbVals} from '../../components/utils/http'
class C18AlarmLog00 extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.loadInfo()
    this.setBreadCrumbs()
    this.state={
      loaded:false,
      showDateRange:"none",// visibility of the date-range calendar popup
      dateFilterActive:false,// whether the From/To filter is currently applied
      filterFromTime:null,// unix seconds, start of selected range
      filterToTime:null,// unix seconds, end of selected range
      dateRangeError:"",// validation message for invalid range selections
      searchText:"",
      selected:{},// map of alarmOccurrenceKey -> true for rows checked for bulk acknowledge/unacknowledge
      ackFilter:"all",// "all" | "unacknowledged" | "acknowledged" - account-wide acknowledgment view filter
      otherCount:0,// alarms this scope hides, shown as a link to the account view
      alarmPage:1,
      sortColumn:"time",
      sortDirection:"desc",
    }
    this.dateRangeRef=React.createRef()
    this.alarmTableRef=React.createRef()

    if(this.props.notify){this.props.notify({id: "newSensor", func: this.onNewSensor})}
    // refresh this page's own alarm list when acknowledgment changes anywhere (this page,
    // the sidebar, etc.) so rows update immediately instead of needing a page reload
    this.subscribe_refreshEvent=globs.events.subscribe("RefreshAlarmEntries",this.refreshAlarms)
}

  componentDidMount=()=>{
    document.addEventListener("mousedown",this.onOutsideClick)
  }

  // the page stays mounted when the scope changes (eg "View all" on a site log),
  // so reload the list for the new site / zone / account
  componentDidUpdate=(prevProps)=>{
    let prev=prevProps.parms||{}
    let p=this.props.parms||{}
    if((prev.site!=p.site)||(prev.zone!=p.zone)||(prev.sensor!=p.sensor)){
      this.setState({alarmPage:1, selected:{}})
      this.setBreadCrumbs()
      this.loadInfo()
    }
  }

  componentWillUnmount=()=>{
    if(this.props.notify){this.props.notify({id: "newSensor", func: this.onNewSensor, unMount: true})}
    document.removeEventListener("mousedown",this.onOutsideClick)
    this.subscribe_refreshEvent.remove()
  }

  refreshAlarms=()=>{
    let alarms=this.getAlarmList()
    this.setState({alarms:alarms, otherCount:this.getOtherCount(alarms)})
  }

  // on a site / zone page: how many more active (unacknowledged) alarms the
  // account view has, so the header badge count doesn't look wrong here
  getOtherCount=(alarms)=>{
    if(this.scope=="account"){return 0}
    let active=list=>{return list.filter(a=>{return (a.level<6)&&!isAlarmAcknowledged(a)}).length}
    return active(this.getAlarmList("account"))-active(alarms)
  }

  setSortColumn=(column)=>{
    let direction="asc"
    if(this.state.sortColumn===column){
      direction=this.state.sortDirection==="asc"?"desc":"asc"
    }
    this.setState({sortColumn:column, sortDirection:direction, alarmPage:1})
  }

  // inactive columns show a dimmed double arrow so they read as sortable
  showSortArrow=(column)=>{
    let active=this.state.sortColumn===column
    return <span className={`sort-arrow${active?" active":""}`}>
      {active?(this.state.sortDirection==="asc"?"↑":"↓"):"↕"}</span>
  }

  getSortedAlarms=(alarms)=>{
    let {sortColumn,sortDirection}=this.state
    return [...alarms].sort((a,b)=>{
      let result=0
      if(sortColumn==="level"){
        result=Number(a.level)-Number(b.level)
      }else if(sortColumn==="time"){
        result=Number(a.time)-Number(b.time)
      }
      return sortDirection==="asc"?result:-result
    })
  }

  onOutsideClick=(e)=>{
    if((this.state.showDateRange=="block")&&this.dateRangeRef.current&&
      !this.dateRangeRef.current.contains(e.target)){
      this.setState({showDateRange:"none"})
    }
  }
  
  onNewSensor=(sensor)=>{
//     cl(sensor)
//     cl(this.props.parms.sensor)
    let alarms=this.getAlarmList()
    this.setState({alarms:alarms, otherCount:this.getOtherCount(alarms)})
//     this.handleNewSensor(sensor.data)
  }
  
  setBreadCrumbs=async()=>{
    await loadSitesInfo()
    await loadZonesInfo()
    let siteName=getSiteName(this.props.parms.site)
    let zoneName=getZoneName(this.props.parms.zone)
    let scope=this.getScope()
//     cl(scope)
    if(this.props.parms){
      let bc=[
        {t:"Sites", url:"/usa/c18/sites"},
      ]
      if((scope=="site")||(scope=="zone")){
        bc.push(
          {t:siteName, url:`/usa/c18/sites/${this.props.parms.site}`}
        )
      }
      if(scope=="zone"){
        bc.push(
          {t:zoneName, url:`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}`},
        )
      }
      bc.push(
        {t:"Alarm Log", url:`/usa/c18/alarmLog`},
      )
//       cl(bc)
      this.props.parms.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: bc},
        },
      )
    }
  }
  
//   componentWillUnmount=()=>{
//     this.subscribe_savePageEvent.remove()
//   }

  getAlarmName=(id)=>{
    
  }
  
  getZoneInfoFromSI=(siteId,index)=>{
    let gzi=globs.zonesInfo.info
    for(let i=0;i<gzi.length;i++){
      let z=gzi[i]
//       cl(z)
      if((z.siteId==siteId)&&(z.siteZoneIndex==index)){return z}
    }
  }
  
  getScope=()=>{
    let p=this.props.parms
    if(p.sensor){return "sensor"}
    if(p.zone){return "zone"}
    if(p.site){return "site"}
    return "account"
  }
  
  makeSensorAlarmCurrentLimit=(zi,type)=>{// duplicated in C18SidebarAlarms00
    let len=type.length
//     cl(type)
    if(type.substring(len-2,len)=="Sa"){
//       cl(type)
      let sensorType=type.substring(0,5)
      let hilo=type.substring(5,7)
//       cl(sensorType)
      
//       cl(zi.current.sensorInfo)
      let ai=zi.current.sensorInfo[sensorType]
      if(ai){
        let current=ai.val+ai.un
        let limit=((hilo=="Hi")?ai.ah:ai.al)+ai.un
        return [current,limit]
      }else{return [0,0]}
//       cl(ai)
    }
  }

  genSenseLimitCurrent=(zi,al)=>{// e0gn002Sa
//     cl(zi)
    let gwType=zi.gatewayType
    if(gwType!=1900){return[]}
    let zInd=zi.siteZoneIndex
    let tabInfo=pInd[gwType].pearl_gen_sens_stat
    let mult=tabInfo[2]
    tabInfo=pInd[gwType].pearl_gen_sens_alrm

    let hiloMult=tabInfo[2]
//     cl(base,mult)
    let curId=getParamId2(gwType,"pearl_gen_sens_stat","adjValue")
    let loId=getParamId2(gwType,"pearl_gen_sens_alrm","alarmLow")
    let hiId=getParamId2(gwType,"pearl_gen_sens_alrm","alarmHigh")
//     cl(loId,hiId)
//     cl(tabInfo)
//     cl(curId)
    let idx=+al.substring(4,7)
//     cl(idx)
    let pid=curId+mult*idx
    let loPid=loId+hiloMult*idx
    let hiPid=hiId+hiloMult*idx
//     cl(loPid,hiPid)
//     cl(pid)
//     cl(zInd)
//     cl(dbVals)
    if(!dbVals.z[zInd]){return[0.0]}
    let curVal=dbVals.z[zInd][240][pid]
    let loVal=dbVals.z[zInd][240][loPid]
    let hiVal=dbVals.z[zInd][240][hiPid]
//     cl(curVal,loVal,hiVal)
    let isLow=curVal<hiVal
    return [(curVal<hiVal)?loVal:hiVal,curVal]
//     return [5,10]
  }
  
  getLimitCurrent=(zi,al)=>{
//     cl(zi,al)// e0gn002LoSa
    let limit="--"//"701 W/m2"
    let current="--"//"1002 W/m2"
    if(al.substring(2,4)=="gn"){return this.genSenseLimitCurrent(zi,al)}
//     cl(zi)
//     cl(al)
    if(zi.current){
      var res
      if(res=this.makeSensorAlarmCurrentLimit(zi,al)){
        [current,limit]=res
      }else{
        switch(al){
          case "ITHi":
            current=zi.current.inTemp
            limit=zi.current.inTempHAL+zi.current.inTempHSP
            break
          case "ITLo":
            break
          default:
            break
        }
      }
    }
//     cl(limit,current)
    return [limit,current]
  }
  
  getAlarmLevel=()=>{
    
    // cl(this.scope)
    return 
  }
  
  getAlarmSensor=(alarmId)=>{
//     let len=alarmId.length
//     let type=alarmId.substring(len-2,len)
    let ty=alarmId.slice(-2)
    if(ty=="Sa"){
      if(alarmId.slice(2,4)=="gn"){
//         cl(alarmId)
        return alarmId.substring(0,7)+"Sa"
      }
      return alarmId.substring(0,5)
    }
  }
  
  getAlarmList=(scopeOvr)=>{// scopeOvr lets us count the account list while on a scoped page
    let st=this.state
    let pa=this.props.parms
    let scope=scopeOvr||this.scope
//     cl(st)
//     cl(pa)
    let alarms=[]
//     cl(globs.alarmsInfo)
//     cl(globs.alarmsInfo.info.filter(a=>{return (a.a.substring(0,4)=="e0gn")&&(a.z==1)}))
//     cl(globs.alarmsInfo.info.filter(a=>{return (a.s=="eDYepwZB3wvTI1Vo")&&(a.z==1)}))
    globs.alarmsInfo.info.forEach(a=>{
//       cl(a)
      let si=getSiteInfo(a.s)
//       cl(a)
      let zi=this.getZoneInfoFromSI(a.s,a.z)// Site-Index
//       cl([si,zi])
      if(si&&zi&&!zi.virtual){
        let ai=getAlarmInfo(a.a,a.s,a.z)||{}
        
//         if(a.a=="e0as0HiSa"){cl(a,ai)}
//         cl(ai)
//         cl(a)
//         cl(ai)
        if(true || ai.enable!=0){
          let level=ai.level
          if(!level){
            level=(a.a.substring(2)=="hrbrd")?7:2
          }
          let aId=a.a
          let name=ai.name
          let site=si.name
          let siteId=si.siteId
          let zone=zi.zoneName||"Unknown"
          let zoneId=zi.zoneId
          let time=a.b
          var limit,current
          let tzo = getTzo(zi)
          let dst = getDst(zi)
          if(scope=="account"){
            limit="--"//"701 W/m2"
            current="--"//"1002 W/m2"
          }else{
            [limit,current]=this.getLimitCurrent(zi,a.a)
          }
          let getIt=false
          let alZone=(globs?.zonesInfo?.sz2z[a.s][a.z]||{})?.zoneId
          var pr
          switch(scope){
            case "account":
              pr=privs("zone",alZone,constant.AREA_PRIVS_READ)
              getIt=pr
              break
            case "site":
              pr=privs("zone",alZone,constant.AREA_PRIVS_READ)
              getIt=pr&&(si.siteId==pa.site)
              break
            case "zone":
              pr=privs("zone",alZone,constant.AREA_PRIVS_READ)
              getIt=pr&zi.zoneId==pa.zone
              break
            case "sensor":
              pr=privs("zone",globs?.zonesInfo?.sz2z[a.s][a.z]?.zoneId,constant.AREA_PRIVS_READ)
//               cl(pa.sensor,this.getAlarmSensor(a.a))
              getIt=(pr&zi.zoneId==pa.zone)&&(pa.sensor==this.getAlarmSensor(a.a))
              break
          }
          if(getIt){
            let sensor=this.getAlarmSensor(a.a)||""
            let sensorName=((siteSensorNames?.[zoneId]?.[sensor]||{}).name)||""
            alarms.push( {level:level,aId:aId,name:name,site:site,siteId:siteId,zone:zone,zoneId:zoneId,
              sensor:sensor,sensorName:sensorName, time:time, limit:limit, current:current,
              tzo: tzo, dst: dst, s:a.s, z:a.z, b:a.b, ack:a.ack, ackBy:a.ackBy, ackAt:a.ackAt} )
          }
        }
      }
    })
    alarms.sort((a,b)=>{
      if(a.time<b.time){return 1}
      if(a.time>b.time){return -1}
      return 0
    })
//     cl(pa.sensor)
//     cl(alarms)
    return alarms
    
  }
  
  toggleDateRange=()=>{
    let show=(this.state.showDateRange=="none")?"block":"none"
    this.setState({showDateRange:show})
  }

  onDateRangeChange=(o)=>{
    let sel=o.selection
    // when no filter is active the range starts as null/null, so the first click can
    // come back with only one side set - treat that as a single day range
    let startDate=sel.startDate||sel.endDate
    let endDate=sel.endDate||sel.startDate
    if(!startDate||!endDate){return}
    if(endDate<startDate){// belt-and-suspenders; the calendar itself won't normally allow this
      this.setState({dateRangeError:"'To' date can't be earlier than 'From' date."})
      return
    }
    let fromTime=Math.floor(startDate.getTime()/1000)
    let toTime=Math.floor(endDate.getTime()/1000)
    this.setState({filterFromTime:fromTime, filterToTime:toTime, dateFilterActive:true,
      dateRangeError:"", alarmPage:1})
  }

  clearDateFilter=()=>{
    if(!this.state.dateFilterActive){return}// no filter applied - nothing to clear
    this.setState({dateFilterActive:false, filterFromTime:null, filterToTime:null,
      dateRangeError:"", showDateRange:"none", alarmPage:1})
  }

  // filters the already-loaded alarms (this.state.alarms) by their start date (a.time/a.b)
  // using the same tzo/dst-adjusted date shown in the Date column, so the filter matches
  // what the user sees on screen. Purely a display filter - does not re-fetch or alter alarms.
  filterAlarmsByDate=(alarms)=>{
    let st=this.state
    if(!st.dateFilterActive||!st.filterFromTime||!st.filterToTime){return alarms}
    let fromStr=dateToDisplayDate(new Date(st.filterFromTime*1000),"yyyy-mm-dd")
    let toStr=dateToDisplayDate(new Date(st.filterToTime*1000),"yyyy-mm-dd")
    return alarms.filter(a=>{
      let da=new Date(a.tzo ? ((a.time + (a.tzo * 60) + (a.dst * 60 * 60))*1000): a.time * 1000)
      let dayStr=(a.tzo) ? dateToDisplayDate(da,"yyyy-mm-dd", 0) : dateToDisplayDate(da,"yyyy-mm-dd")
      return (dayStr>=fromStr)&&(dayStr<=toStr)// inclusive of both boundary dates
    })
  }

  // account-wide acknowledgment view filter ("all" | "unacknowledged" | "acknowledged").
  // Purely a display filter over the already-loaded alarms - it does not mark anything.
  filterAlarmsByAck=(alarms)=>{
    let af=this.state.ackFilter
    if(af=="all"){return alarms}
    return alarms.filter(a=>{
      let acked=isAlarmAcknowledged(a)
      return (af=="acknowledged")?acked:!acked
    })
  }

  filterAlarmsBySearch=(alarms)=>{
    let search=this.state.searchText.trim().toLowerCase()
    if(!search){return alarms}
    if(/^\d+$/.test(search)){
      return alarms.filter(a=>Number(a.level)===Number(search))
    }
    return alarms.filter(a=>{
      return [a.site,a.zone,a.name,a.sensor,a.sensorName,a.aId]
        .some(value=>(value||"").toString().toLowerCase().includes(search))
    })
  }

  rowKey=(a)=>{return alarmOccurrenceKey(a.s,a.z,a.aId,a.time)}

  toggleSelect=(key)=>{
    let sel=Object.assign({},this.state.selected)
    if(sel[key]){delete sel[key]}else{sel[key]=true}
    this.setState({selected:sel})
  }

  toggleSelectAll=(visibleAlarms)=>{
    let sel=Object.assign({},this.state.selected)
    let keys=visibleAlarms.map(a=>this.rowKey(a))
    let allSel=(keys.length>0)&&keys.every(k=>sel[k])
    if(allSel){keys.forEach(k=>{delete sel[k]})}// unselect all visible
    else{keys.forEach(k=>{sel[k]=true})}// select all visible
    this.setState({selected:sel})
  }

  setAckFilter=(v)=>{this.setState({ackFilter:v, selected:{}, alarmPage:1})}

  setAlarmPage=(page,totalPages)=>{
    this.setState({alarmPage:Math.max(1,Math.min(page,totalPages))}, ()=>{
      document.body.scrollTo({top:0, left:0, behavior:"smooth"})
    })
}

  // marks the currently selected (and visible) rows acknowledged/unacknowledged for the
  // whole account, then clears the selection. Updates immediately via isAlarmAcknowledged
  // on re-render.
  markSelected=(ack)=>{
    let st=this.state
    let visibleAlarms=this.filterAlarmsBySearch(
      this.filterAlarmsByAck(this.filterAlarmsByDate(st.alarms))
    ).filter(a=>{return a.level<6})
    let chosen=visibleAlarms.filter(a=>st.selected[this.rowKey(a)])
    if(!chosen.length){return}
    markAlarmsAcknowledged(chosen, ack)
    this.setState({selected:{}})
  }

  loadInfo=async()=>{
    await loadSitesInfo()
    await loadZonesInfo()
    await loadAlarmsInfo()
    await loadSensorsInfo()
    await loadMBInfo()
//     cl(globs)
//     cl(globs.alarmsInfo.info)
    await loadAddedSensorsInfo()
//     cl("load added sensors")
//     cl(globs.addedSensorsInfo.info)
//     cl(globs.alarmsInfo.info)
    let pa=this.props.parms
    if(pa.site){
      await loadSiteData(pa.site)
      await makeSiteSensorNames(pa.site)
//       cl("loading site")
    }
    setSiteZoneTypes(pa.site)
    this.scope=this.getScope()
    if(this.scope!="account"){await getZoneAlarmInfo(globs.userData.session.siteId)}
    let alarms=this.getAlarmList()
    // get timezone info
    if(["zone", "sensor"].includes(this.scope)) {
      let zInd=getZoneIndex(this.props.parms.zone)
    }
//     cl(alarms)
    this.setState({loaded:true, alarms:alarms, otherCount:this.getOtherCount(alarms),/*siteSel:siteSel,zoneSel:zoneSel*/})
  }
  
  showAlarmLines=(showLimit,alarms,isFullPage)=>{
//     let alarmToSensor={ITHi:"inT",ITHi:"inT",ITSn:"inT",}
//     cl(globs.zonesInfo.info)
//     cl(this.state.alarms)
    return alarms.map((a,i)=>{
//       cl(a.aId)
//       cl(a.name)
      if(a.level<6){
        // add tzo if present to a.time
        let da=new Date(a.tzo ? ((a.time + (a.tzo * 60) + (a.dst * 60 * 60))*1000): a.time * 1000)
        // cl(da)
        // cl(a.time*1000)
        // cl(this.state.tzo)
        // only get utc disp time if tzo is present
        let dispDate=(a.tzo) ? dateToDisplayDate(da,"mm/dd/yyyy h:mm ap", 0) : dateToDisplayDate(da,"mm/dd/yyyy h:mm ap")
//         let page=(alarmToSensor(a.aId))?`/sensor/${alarmToSensor[a.aId]}`:""
        let url=`/usa/c18/sites/${a.siteId}/zones/${a.zoneId}/SPalarms`//${page}
        let acked=isAlarmAcknowledged(a)
        let key=this.rowKey(a)
        return(
          <tr key={i} className={acked?"acknowledged-alarm":"unread-alarm"}>
            {isFullPage&&
              <td className="alarm-select-cell"><input type="checkbox" checked={!!this.state.selected[key]}
                onChange={e=>this.toggleSelect(key)}/></td>
            }
            <td className="alarm-level-cell">
              <span translate="no" className={`small-alarm-icon${(a.level<=3)?" urgent-alarm":""}`}>
                <span translate="no" className="material-icons-outlined">notifications_active</span> <span className="alarm-level">{a.level}</span>
              </span>
            </td>
          <td className="alarm-name-cell"><span className="alarm-name-content">{!acked&&<span className="unread-dot" title="Not Acknowledged"></span>}<C18Anchor00 to={url}><span>{a.name}</span></C18Anchor00></span>
          </td>
          <td translate="no" className="alarm-site-cell"><span>{a.site}</span></td><td translate="no" className="alarm-zone-cell"><span>{a.zone}</span></td><td className="alarm-date-cell">{dispDate} {a.tzo ? getTZIndicator(a.tzo): ""}</td>
          {showLimit&&[<td key="0">{a.limit}</td>,<td key="1">{a.current}</td>]}

          </tr>
        )
      }
    })
  }

  // ======== Alarm mobile view =========

  showMobileAlarmCards=(alarms,isFullPage)=>{
    return alarms.map((a,i)=>{
      let da=new Date(a.tzo ? ((a.time + (a.tzo * 60) + (a.dst * 60 * 60))*1000): a.time * 1000)
      let dispDate=(a.tzo) ? dateToDisplayDate(da,"mm/dd/yyyy h:mm ap", 0) : dateToDisplayDate(da,"mm/dd/yyyy h:mm ap")
      let url=`/usa/c18/sites/${a.siteId}/zones/${a.zoneId}/SPalarms`
      let acked=isAlarmAcknowledged(a)
      let key=this.rowKey(a)
      return(
        <C18Anchor00 key={i} to={url} className={`alarm-mobile-card${acked?" acknowledged-alarm":""}`}>
          {isFullPage&&
            // stopPropagation keeps the card's link from opening when ticking the box.
            // no preventDefault here - that would also block the checkbox itself
            <span className="alarm-mobile-select" onClick={e=>e.stopPropagation()}>
              <input type="checkbox" checked={!!this.state.selected[key]}
                onChange={e=>this.toggleSelect(key)} aria-label="Select alarm"/>
            </span>
          }
          <span translate="no" className={`small-alarm-icon${a.level<=3?" urgent-alarm":""}`}>
            <span translate="no" className="material-icons-outlined">notifications_active</span>
            <span className="alarm-level">{a.level}</span>
          </span>
          <span className="alarm-mobile-card-content">
            <strong>{a.name}</strong>
            <span>{a.site}</span>
            <span>{a.zone}</span>
            <small>{dispDate} {a.tzo ? getTZIndicator(a.tzo): ""}</small>
          </span>
        </C18Anchor00>
      )
    })
  }
  
  makePageName=()=>{
    let scope=this.getScope()
    var zInd,name
    let p=this.props.parms
    switch(scope){
      case "account":
        return "Account Alarm Notifications"
      case "site":
        let si=getSiteInfo(this.props.parms.site)
//         cl(si)
        return `${si.name} Alarm Notifications`
      case "zone":
        zInd=getZoneIndex(this.props.parms.zone)
        name=globs.zonesInfo.info[zInd].zoneName
        return `${name} Alarm Notifications`
      case "sensor":
        zInd=getZoneIndex(this.props.parms.zone)
//         name=globs.zonesInfo.info[zInd].zoneName
//         cl(sensorIds)
//         cl(p)
//         cl(siteSensorNames)
        let se=p.sensor
//         cl(se)
        if(["ec","ph"].includes(se.substring(2,4))){se=se.substring(0,4)}
        if(se.substring(2,4)=="gn"){// e0gn002Sa
          se=se.substring(0,2)+"gn"+(+se.substring(4,7))
//           cl(se)
        }
        // cl(siteSensorNames)
        // cl(p.zone)
        // cl(se)
        name=`${globs.zonesInfo.info[zInd]?.zoneName} ${((siteSensorNames[p.zone]||{})[se]||{}).name}`
        return `${name} Alarm Notifications`
    }
    return scope
  }
  
  sendTestAlarm=()=>{
    cl("sending test msg")
    let buttons = []
    buttons[0] = {text: "Log in GJ", cmd: "gj", data: {method: "create", body: {
      msg: "This is an example of a GJ created from a push notification.\n Good for logging important alarms.",
      tags: ["sensors", "other"]
    }}
    }
    buttons[1] = {text: "View", cmd: "url", data: {url: "http://beta.c2.link4cloud.com/usa/c18/alarmLog"}}
    buttons[2] = {text: "Dismiss", cmd: "", data: {}}
    let fakeAlarm = {
      // Name: "Inside Temperature Low Alarm",
      Site: "Anaheim, CA",
      Zone: "Cherry Tomatoes",
      Time: dateToDisplayDate(new Date(),"mm/dd/yyyy h:mm ap"),
      Limit: "95.0 F",
      Current: "98.8 F",
      Level: 1,
      buttons: buttons
    }
    let name = "Inside Temperature Low Alarm"
    wsTrans("usa", {cmd: "cRest", uri: "/s/pushNote", method: "update", 
      sessionId: globs.userData.session.sessionId,
      body: {
        userIds: [globs.userData.session.userId],
        title: `Test Alarm Notification`,
        body: fakeAlarm,
        topic: "alarm",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJiMe2sF84-H1gwFr7qbUNcyBE2i7jQrPg4Q&usqp=CAU",
    }})

    // wsTrans("usa", {cmd: "cRest", uri: "/s/pushNote", method: "update", 
    //   sessionId: globs.userData.session.sessionId,
    //   body: {
    //     userIds: [globs.userData.session.userId],
    //     title: name,
    //     body: JSON.stringify(fakeAlarm),
    //     topic: "alarm",
    //     url: "http://stage.c2.link4cloud.com:3114/usa/c18/alarmLog",
    //     cmd: "",
    //   }})
  }

  render(){
    if(this.state.loaded){
//       cl("loaded")
      // let showLimit=(this.scope!="account")
      // let isFullPage=(this.props.parms.mode=="fullPage")// checkboxes + ack filter/action controls: only on the dedicated alarm log page, not the embedded sensor-page widget
      let isFullPage=(this.props.parms.mode=="fullPage")// checkboxes + ack filter/action controls: only on the dedicated alarm log page, not the embedded sensor-page widget
      let showLimit=!isFullPage
      let name=this.makePageName()
//       cl(name)
      let p=this.props.parms
      let st=this.state
//       cl(p.sensor)
//       cl(showLimit)
//       cl(name)
      let filteredAlarms=this.filterAlarmsBySearch(
        this.filterAlarmsByAck(this.filterAlarmsByDate(st.alarms))
      )
      let visibleAlarms=filteredAlarms.filter(a=>{return a.level<6})
      let isMobileAlarmView=typeof window!=="undefined"&&window.innerWidth<=767
      let alarmsPerPage=isMobileAlarmView?26:25
      let totalPages=Math.max(1,Math.ceil(visibleAlarms.length/alarmsPerPage))
      let alarmPage=Math.min(st.alarmPage,totalPages)
      let pageStart=(alarmPage-1)*alarmsPerPage
      let sortedAlarms=this.getSortedAlarms(visibleAlarms)
      let displayedAlarms=sortedAlarms.slice(pageStart,pageStart+alarmsPerPage)
      let allAlarms=st.alarms.filter(a=>{return a.level<6})
      let acknowledgedCount=allAlarms.filter(a=>isAlarmAcknowledged(a)).length
      let activeCount=allAlarms.length-acknowledgedCount
      // summary card counts: big number is this scope's total, second line is the
      // date-range count. Date filter only, so search or the selected card don't change them
      let rangeAlarms=st.dateFilterActive?this.filterAlarmsByDate(allAlarms):allAlarms
      let rangeAcknowledgedCount=rangeAlarms.filter(a=>isAlarmAcknowledged(a)).length
      let rangeActiveCount=rangeAlarms.length-rangeAcknowledgedCount
      let inRange=(n)=>{return `${n} in this date range`}
      let selCount=visibleAlarms.filter(a=>st.selected[this.rowKey(a)]).length
      let allSelected=(visibleAlarms.length>0)&&(selCount==visibleAlarms.length)
      let noMatches=(st.dateFilterActive||st.searchText.trim())&&(visibleAlarms.length==0)
      let tp={
        startDate: st.dateFilterActive ? new Date(1000*st.filterFromTime) : null,
        endDate: st.dateFilterActive ? new Date(1000*st.filterToTime) : null,
        key:'selection',
      }
      let rangeLabel=st.dateFilterActive
        ? `${dateToDisplayDate(tp.startDate,"mm/dd/yyyy")} - ${dateToDisplayDate(tp.endDate,"mm/dd/yyyy")}`
        : "All Dates"
      return(
        <div className={isFullPage?"alarm-log-page":""}>
        {isFullPage
          ? <div className="alarm-log-heading">
              <span translate="no" className="alarm-log-heading-icon material-icons-outlined">shield</span>
              <div>
                <h1>{name}</h1>
                <p>Monitor and review alarm events from your greenhouse environment.</p>
              </div>
            </div>
          : <h2>{name}</h2>
        }
              {isFullPage&&(st.otherCount>0)&&
                <p>{`${st.otherCount} more alarm${(st.otherCount==1)?"":"s"} in this account. `}
                  <C18Anchor00 to="/usa/c18/alarmLog" className="colored-link-text">View all</C18Anchor00>
                </p>
              }
              {isFullPage&&
                <div className="alarm-summary-grid">
                  <div className={`alarm-summary-card active${st.ackFilter=="unacknowledged"?" selected":""}`}
                    onClick={()=>this.setAckFilter("unacknowledged")}
                    onKeyDown={(e)=>{if(e.key==="Enter"||e.key===" "){e.preventDefault(); this.setAckFilter("unacknowledged")}}}
                    role="button" tabIndex={0}>
                    <span translate="no" className="material-icons-outlined">notifications_active</span>
                    <div><strong>{activeCount}</strong><b>Active Alarms</b>
                      <small>{st.dateFilterActive?inRange(rangeActiveCount):"Require attention"}</small></div>
                  </div>
                  <div className={`alarm-summary-card acknowledged${st.ackFilter=="acknowledged"?" selected":""}`}
                    onClick={()=>this.setAckFilter("acknowledged")}
                    onKeyDown={(e)=>{if(e.key==="Enter"||e.key===" "){e.preventDefault(); this.setAckFilter("acknowledged")}}}
                    role="button" tabIndex={0}>
                    <span translate="no" className="material-icons-outlined">schedule</span>
                    <div><strong>{acknowledgedCount}</strong><b>Acknowledged</b>
                      <small>{st.dateFilterActive?inRange(rangeAcknowledgedCount):"Reviewed alarms"}</small></div>
                  </div>
                  <div className={`alarm-summary-card total${st.ackFilter=="all"?" selected":""}`}
                    onClick={()=>this.setAckFilter("all")}
                    onKeyDown={(e)=>{if(e.key==="Enter"||e.key===" "){e.preventDefault(); this.setAckFilter("all")}}}
                    role="button" tabIndex={0}>
                    <span translate="no" className="material-icons-outlined">description</span>
                    <div><strong>{allAlarms.length}</strong><b>Total Alarms</b>
                      <small>{st.dateFilterActive?inRange(rangeAlarms.length):"All loaded alarms"}</small></div>
                  </div>
                </div>
              }
              <div className={isFullPage?"alarm-log-toolbar":""}>
              {isFullPage&&
                <div className="time-period-container alarm-date-filter" ref={this.dateRangeRef}
                  onClick={e=>{e.preventDefault(); e.stopPropagation()}}>
                  <C18Button00 type="button" className="icon" onClick={this.toggleDateRange}>
                    {rangeLabel}
                    <span translate="no" className="material-icons down-arrow">keyboard_arrow_down</span>
                  </C18Button00>
                  <C18Button00 type="button" className="outlined" style={{marginLeft:10}}
                    onClick={this.clearDateFilter}>Clear</C18Button00>
                  <span style={{marginLeft:10}}>
                    {visibleAlarms.length} alarm{(visibleAlarms.length==1)?"":"s"}
                  </span>
                  {st.dateRangeError&&
                    <div style={{color:"#cc0000", marginTop:5}}>{st.dateRangeError}</div>
                  }
                  <div style={{position:"relative"}}>
                    <div style={{position:"absolute", display:st.showDateRange, zIndex:10}}>
                      <DateRangePicker
                        className={st.dateFilterActive ? "" : "no-date-range"}
                        ranges={[tp]}
                        onChange={this.onDateRangeChange}
                        inputRanges={[]}
                      />
                    </div>
                  </div>
                </div>
              }
              {isFullPage&&
                <div className="alarm-read-controls">
                  <span className="ack-filter-select">
                    <span translate="no" className="material-icons-outlined filter-icon" title="Filter">filter_alt</span>
                    <span className="custom-select">
                      <select value={st.ackFilter} onChange={e=>this.setAckFilter(e.target.value)} aria-label="Acknowledgment filter">
                        <option value="all">All</option>
                        <option value="unacknowledged">Not Acknowledged</option>
                        <option value="acknowledged">Acknowledged</option>
                      </select>
                      <span translate="no" className="material-icons down-arrow">keyboard_arrow_down</span>
                    </span>
                  </span>
                  <button type="button" className="outlined" style={{marginLeft:15}}
                    disabled={selCount==0} onClick={e=>this.markSelected(true)}>Acknowledge</button>
                  <button type="button" className="outlined"
                    disabled={selCount==0} onClick={e=>this.markSelected(false)}>Unacknowledge</button>
                  {(selCount>0)&&<span style={{marginLeft:10}}>{selCount} selected</span>}
                </div>
              }
              {isFullPage&&
                <div className="alarm-search-filter">
                  <span className="material-icons-outlined" title="Search">search</span>
                  <input type="search" placeholder="Search"
                    value={st.searchText}
                    onChange={e=>this.setState({searchText:e.target.value, alarmPage:1})}
                    aria-label="Search site, zone, sensor or alarm" />
                </div>
              }
              </div>
              <div className={`table-container${isFullPage?" alarm-table-card":""}`} ref={this.alarmTableRef}>
                <table className="active-alarms-table"><tbody>
                  {false&&
                    <tr className="bottom-padding">
                      <td><input type="checkbox" /></td>
                      <td colSpan="8"><button type="button" className="outlined">Snooze Selected Alarms</button></td>
                    </tr>
                  }
                  <tr className="spacer">
                    <td colSpan="9"></td>
                  </tr>
                  <tr>
                    {isFullPage&&
                      <th className="alarm-select-cell"><input type="checkbox" checked={allSelected}
                        onChange={e=>this.toggleSelectAll(visibleAlarms)} title="Select all"/></th>
                    }
                    <th className="sortable-col alarm-level-cell" title="Sort by level" onClick={()=>this.setSortColumn("level")}>
                      Level {this.showSortArrow("level")}
                    </th><th>Alarm</th><th>Site</th><th>Zone</th>
                    <th className="sortable-col alarm-date-cell" title="Sort by date" onClick={()=>this.setSortColumn("time")}>
                      Date {this.showSortArrow("time")}
                    </th>
                    {showLimit&&[<th key="0">Limit</th>,<th key="1">Current</th>]}
                  </tr>
                  {noMatches
                    ? <tr><td colSpan={5+(showLimit?2:0)+(isFullPage?1:0)} style={{textAlign:"center", padding:"20px 0"}}>
                        No matching alarms.</td></tr>
                    : this.showAlarmLines(showLimit,displayedAlarms,isFullPage)
                  }
                </tbody></table>
              </div>
              <div className="alarm-mobile-cards">
                {isFullPage&&
                  <label className="alarm-mobile-select-all">
                    <input type="checkbox" checked={allSelected}
                      onChange={e=>this.toggleSelectAll(visibleAlarms)}/>
                    Select all
                  </label>
                }
                <div className="alarm-mobile-sort-controls">
                  <button type="button" className={st.sortColumn==="level"?"active":""}
                    onClick={()=>this.setSortColumn("level")}>Level {this.showSortArrow("level")}</button>
                  <button type="button" className={st.sortColumn==="time"?"active":""}
                    onClick={()=>this.setSortColumn("time")}>Date {this.showSortArrow("time")}</button>
                </div>
                {noMatches
                  ? <div className="alarm-mobile-empty">No matching alarms.</div>
                  : this.showMobileAlarmCards(displayedAlarms,isFullPage)
                }
              </div>
              <br/>
              {(visibleAlarms.length>alarmsPerPage)&&
                <div className="pagination-wrapper">
                  <div className="alarm-log-pagination report-paging paging">
                    <button type="button" className="back-to-beginning" aria-label="first page"
                      disabled={alarmPage==1} onClick={()=>this.setAlarmPage(1,totalPages)}>&#171;</button>
                    <button type="button" className="back" aria-label="previous page"
                      disabled={alarmPage==1} onClick={()=>this.setAlarmPage(alarmPage-1,totalPages)}>&#8249;</button>
                    <span className="page-range">{`${pageStart+1}-${Math.min(pageStart+alarmsPerPage,visibleAlarms.length)} of ${visibleAlarms.length}`}</span>
                    <button type="button" className="forward" aria-label="next page"
                      disabled={alarmPage==totalPages} onClick={()=>this.setAlarmPage(alarmPage+1,totalPages)}>&#8250;</button>
                    <button type="button" className="forward-to-end" aria-label="last page"
                      disabled={alarmPage==totalPages} onClick={()=>this.setAlarmPage(totalPages,totalPages)}>&#187;</button>
                  </div>
                </div>
              }  
              {false&&
                <div className="report-paging paging">
                  <button type="button" className="back-to-beginning" aria-label="first page">&#171;</button>
                  <button type="button" className="back" aria-label="previous page">&#8249;</button>
                  <span className="page-range">1-99 of 200</span> 
                  <button type="button" className="forward" aria-label="next page">&#8250;</button>
                  <button type="button" className="forward-to-end" aria-label="last page">&#187;</button>
                </div>
              }
              <div className="clearfloat"></div>
        </div>
      )
    }else{
      return <LoadingSpinner message="loading alarm log..." />
    }
  }
}

export default C18AlarmLog00;
